<template>
  <div>
    <b-container v-if="status==0" fluid>
      <h4>Set parameters:</h4>    
      <b-row class="my-2">
        <b-col sm="1" class="pt-1">Survey type</b-col>
        <b-col sm="2">
          <b-form-select 
            :options="surveytypes" 
            v-model="surveytype_id"
            @change="languages_get();normvalues_get();"  
          >
          </b-form-select>
        </b-col>
        <b-col sm="1" class="pt-1">Normvalues</b-col>
        <b-col sm="2">
          <b-form-select :options="normvalues" v-model="normvalues_id">
          </b-form-select>
        </b-col>
        <b-col sm="1" class="pt-1">Language</b-col>
        <b-col sm="2">
          <b-form-select :options="languages" v-model="language_id">
          </b-form-select>
        </b-col>
        <b-col sm="3">
          <b-button @click.prevent="createSurveys" variant="primary" :disabled="groups.length===0">Create groups and surveys</b-button>
        </b-col>           
      </b-row>
      <h4>Create groups and surveys:</h4>
      <b-row class="my-1">
        <b-col sm="4">
          Group Name
        </b-col>
        <b-col sm="1">
          Members
        </b-col>
        <b-col sm="1">
          Surveys
        </b-col>
        <b-col sm="2">
          Start date
        </b-col>
        <b-col sm="2">
          Surveys interval months
        </b-col>
        <b-col sm="2">
          <b-button
            class="col-8"
            @click.prevent="addGroup"
          >
            <fa-icon
                class="mr-2"
                name="plus"
            />Add
          </b-button>
        </b-col>      
      </b-row>
      <b-row class="py-2" v-bind:key="group.id" v-for="group in groups">
        <b-col sm="4">
          <b-form-input
            v-model="group.groupName"
          />
        </b-col>
        <b-col sm="1">
          <b-form-input
            v-model="group.numberMembers"
          />
        </b-col>
        <b-col sm="1">
          <b-form-input
            v-model="group.numberSurveys"
          />
        </b-col>
        <b-col sm="2">
          <datetime
            format="yyyy-LL-dd"
            v-model="group.startDate"
            value-zone="Europe/Stockholm"
            zone="Europe/Stockholm"
            :phrases="{ok: 'OK', cancel: 'Cancel'}"
          >
          </datetime>
        </b-col>
        <b-col sm="2">
          <b-form-input
            v-model="group.monthsBetween"
          />
        </b-col>
        <b-col sm="2">
          <b-button
            class="col-8"
            variant="danger"
            @click.prevent="removeGroup(group.id)"
          >
            <fa-icon
                class="mr-2"
                name="trash"
            />Remove
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-container v-if="status==1" fluid>
      <h4>Generating testdata...</h4>
    </b-container>
    <b-container v-if="status==2" fluid>
      <h4>Testdata generated</h4>
    </b-container>
  </div>
</template>
<script>
import { Datetime } from 'vue-datetime';
import axios from 'axios'
import { config } from '../../config';
const base_url = config.base_url;

export default {
  name: 'GenerateTestData',
  components: {
    Datetime
  },
  created() {
    this.surveytypes_get();
    this.normvalues_get();
    this.languages_get();
  },
  data: function() {
    return {
      status: 0,
      surveytype_id: 1,
      surveytypes: [],
      normvalues_id: 999,
      normvalues: [],
      language_id: 38,
      languages: [],
      groups: [],
    }
  },
  methods: {
    createSurveys() {
      this.status = 1;
      const record = {
        groups: this.groups,
        surveytype_id: this.surveytype_id,
        normvalues_id: this.normvalues_id,
        language_id: this.language_id,
      }
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+this.$store.state.token;
      return new Promise((resolve) => {
        axios.post(
          base_url+"/gdq_testdata_create",
          JSON.stringify(record), {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json",
            }
          }
        )
        .then((resp) => {
          this.status = 2;
          resolve(resp);
        })
      });
    },
    addGroup() {
      const id = this.groups.length + 1;
      this.groups.push({
        id: id,
        groupName: `Group ${id}`,
        numberMembers: 3,
        numberSurveys: 3,
        startDate: '2021-01-01',
        monthsBetween: 3,
      });

    },
    removeGroup(id) {
      this.groups = this.groups.filter(g => g.id != id);
    },
    surveytypes_get() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+this.$store.state.token;
      return new Promise((resolve) => {
        axios.get(base_url+"/g_surveytypes")
        .then((resp) => {
          this.surveytypes = resp.data.result.map(
            r => { return { value: r.id, text: r.surveytype_name } }
          );
          resolve(resp);
        });                
      });
    },
    normvalues_get() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+this.$store.state.token;
      return new Promise((resolve) => {
        axios.get(base_url+"/gdq_normvalues_countries")
        .then((resp) => {
          this.normvalues = resp.data.map(
            r => { return { value: r.country_id, text: r.country_name } }
          );
          resolve(resp);
        });                
      });

    },
    languages_get() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+this.$store.state.token;
      let filter = {};
      if (this.surveytype_id == 2) { filter.language_enabled_gdq_short =  { operator: "=", value: 1, }}
      if (this.surveytype_id == 3) { filter.language_enabled_gdq_osc =  { operator: "=", value: 1, }}
      return new Promise((resolve) => {
        axios.get(base_url+"/g_languages?filter="+JSON.stringify(filter))
        .then((resp) => {
          this.languages = resp.data.result.map(
            r => { return { value: r.id, text: r.language_name } }
          );
          resolve(resp);
        });                
      });
    },
  },
}
</script>
<style scoped>

</style>